import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import compose from 'helpers/compose';
import { Switch } from 'react-router';
import * as routes from 'routes';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import Layout from 'components/Layout';
import CrumbRoute from 'components/CrumbRoute';

import { Params } from '../Edit/accountEditRoutes';
import ContractDocuments from 'pages/Accounts/Edit/Contract/ContractDocuments/ContractDocuments';
import { RootStore } from 'stores/rootStore';
import { API_LOG_LOAD_ACCOUNT } from 'api/endpoints';

interface Props {
  rootStore: RootStore;
}

const DocumentsToBeSigned: React.FC<Props> = ({ rootStore }) => {
  const { accountId } = useParams<Params>();
  const { t } = useTranslation();

  useEffect(() => {
    rootStore.stores.editAccountStore.fetchBasicData(accountId);
    rootStore.stores.apiStore.post(API_LOG_LOAD_ACCOUNT(accountId));
    rootStore.stores.uiStore.setCurrentAccountId(accountId);

    return () => {
      rootStore.stores.uiStore.unsetCurrentAccountId();
    };

  }, [rootStore.stores.editAccountStore, rootStore.stores.apiStore, rootStore.stores.uiStore, accountId]);

  return (
    <Layout
      title={t('pageTitle_accountComplete', {
        accountName: rootStore.stores.editAccountStore.accountName,
      })}
    >
      <Switch>
        <CrumbRoute
          exact
          title={[t('navMenu_accounts'), `${accountId}`, 'Dokumentace']}
          path={routes.ACCOUNTS_DOCUMENTS()}
          render={() =>
            rootStore.stores.editAccountStore.data ? <ContractDocuments toBeSigned /> : null
          }
          home={routes.ACCOUNTS_DRAFTS}
        />
      </Switch>
    </Layout>
  );
};

export default compose(inject('rootStore'), observer)(DocumentsToBeSigned);
